import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import promission from './modules/promission'
import header from './modules/header'
import activeRouter from './modules/activeRouter'
import systemParam from './modules/systemParam'
import commonValidate from './modules/commonValidate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    login,
    promission,
    header,
    activeRouter,
    systemParam,
    commonValidate
  }
})

export default store
